module.exports = __webpack_public_path__ + "static/media/icq-logo.86563d29.png";